var ReadMore = class extends HTMLElement {
    constructor() {
        super();
        this.expanded = false;
    }

    connectedCallback () {
        this.content = this.querySelector(".content");
        this.button = this.querySelector("button");

        this.updateState();
        this.button.addEventListener("click", () => this.toggle());
    }

    toggle () {
        this.expanded = !this.expanded;
        this.updateState();
    }

    updateState () {
        if (this.expanded) {
            this.content.classList.add("expanded");
            this.button.textContent = this.button.dataset.expandedText;
        } else {
            this.content.classList.remove("expanded");
            this.button.textContent = this.button.dataset.collapsedText;
        }
    }
};

customElements.define('read-more', ReadMore);
